// Occupational Health and Safety page English translations

export default {
  pageTitle: "Sustainability",
  breadcrumbHome: "Home",
  breadcrumbSustainability: "Sustainability",
  breadcrumbCurrent: "Occupational Health and Safety Initiatives",
  
  // Page Header
  title: "Occupational Health and Safety Initiatives",
  
  // Navigation
  navSustainability: "Sustainability",
  navConceptOfSustainability: "Concept of Sustainability",
  navEnvironmentalInitiatives: "Environmental Initiatives",
  navSocialContributionInitiatives: "Social Contribution Initiatives",
  
  // Main Content
  mainTitle: "Occupational Health and Safety at Eagle Industry Indonesia",
  mainDescription: "The EKK Group always strives to build a work environment that supports the physical and mental well-being of employees. The principle of Safety underlies that safety is not only a pillar of the company, but also of individuals within the Group.",
  
  // Health and Safety Management
  healthSafetyManagementTitle: "Our Health and Safety Management",
  healthSafetyManagementDesc: "Occupational safety is our top priority. The EKK Group manages OHS through a structured organization led directly by top management. By implementing the international standard ISO 45001:2018 (Occupational Health and Safety), we ensure that all operational activities run safely, healthily, and sustainably.",
  
  // OHS Policies
  ohsPoliciesTitle: "EKK Occupational Health and Safety Policies",
  
  // Basic Group Safety Principle
  basicSafetyPrincipleTitle: "Basic Group Safety Principle",
  basicSafetyPrincipleDesc: "Safety is not only fundamental for management that respects human dignity, but also the personal desire and mission of all Group employees.",
  
  // Basic Concept
  basicConceptTitle: "Basic Concept",
  basicConceptDesc: "Based on the Group's Basic Safety Principle, the EKK Group develops human resources who are healthy physically and mentally. At the same time, improving the OHS management system and involving relevant parties to create a comfortable, safe, and motivating work environment.",
  
  // Activity Policy
  activityPolicyTitle: "Activity Policy",
  activityPolicy1: "Properly identify hazards related to business activities, assess risks, and control hazards by considering the hierarchy of controls to reduce risks with the participation and cooperation of all employees.",
  activityPolicy2: "Establish occupational health and safety targets and pursue better performance through continuous improvement.",
  activityPolicy3: "Comply with applicable laws and regulations as well as other requirements.",
  activityPolicy4: "Value active discussions in the workplace, recognizing that good communication is an integral part of occupational health and safety.",
  activityPolicy5: "Provide necessary education and training to ensure occupational health and safety while increasing employee awareness of the importance of health and safety.",
  
  // OHS Performance
  ohsPerformanceTitle: "OHS Performance",
  safetyCertification: "Safety Certification",
  ltiRate: "LTI Rate",
  safetyTraining: "Safety Training",
  healthCheckups: "Health Check-ups",
  safetyInspections: "Safety Inspections",
  emergencyDrills: "Emergency Drills",
  
  // Performance Metrics
  performanceTitle: "OHS Performance and Targets",
  performanceSubtitle: "Our commitment to measurable safety improvements",
  performanceIndicator: "Performance Indicator",
  target: "Target",
  currentPerformance: "Current Performance",
  
  ltiRateLabel: "Lost Time Injury (LTI) Rate",
  totalRecordableInjuryRate: "Total Recordable Injury Rate",
  safetyTrainingCompletion: "Safety Training Completion",
  hazardIdentification: "Hazard Identification",
  emergencyResponseTime: "Emergency Response Time",
  
  performanceNote: "Note: Performance indicators are monitored monthly and reviewed annually for continuous improvement.",
  
  // Safety Activities
  safetyActivitiesTitle: "Safety Activities",
  safetyActivitiesSubtitle: "Our commitment to safety through various programs and initiatives",
  safetyTrainingOverview: "Safety Training Overview",
  
  // Training Activity
  trainingTitle: "Training",
  trainingDesc: "Training with topics on B3 Information System and Environmental Aspect Identification in the Workplace is routinely conducted every year to maintain understanding and increase employee awareness. These training sessions are designed to ensure all employees are equipped with the necessary knowledge to identify and handle hazardous materials safely.",
  trainingHighlight1: "Annual B3 (Hazardous Materials) Information System training",
  trainingHighlight2: "Environmental Aspect Identification in Workplace sessions",
  trainingHighlight3: "Continuous education to maintain safety awareness",
  trainingHighlight4: "Practical demonstrations and hands-on exercises",
  b3TrainingSession: "B3 Training Session",
  hazardIdentificationWorkshop: "Hazard Identification Workshop",
  
  // Safety Patrol Activity
  safetyPatrolTitle: "Safety Patrol",
  safetyPatrolDesc: "As an effort to create a safe work environment, the company conducts monthly Safety Patrols involving the HSE team, Sachou (President Director), and Managers from all departments. This activity focuses on identifying hazardous conditions and ensuring proper implementation of 5S methodology in the work area.",
  safetyPatrolHighlight1: "Monthly safety patrols with cross-departmental participation",
  safetyPatrolHighlight2: "Focus on hazardous condition identification",
  safetyPatrolHighlight3: "5S implementation monitoring and evaluation",
  safetyPatrolHighlight4: "Regular follow-up meetings to review improvements",
  monthlySafetyPatrol: "Monthly Safety Patrol",
  fiveSImplementationCheck: "5S Implementation Check",
  
  // Emergency Plan Activity
  emergencyPlanTitle: "Emergency Plan",
  emergencyPlanDesc: "In facing emergency situations, the company has established structured handling steps. One potential emergency situation anticipated is fire. The company has comprehensive prevention plans, training programs, awareness campaigns, and routine inspections to ensure preparedness for any emergency situation.",
  emergencyPlanHighlight1: "APAR (Light Fire Extinguisher) training and practice",
  emergencyPlanHighlight2: "Regular evacuation simulations and drills",
  emergencyPlanHighlight3: "Emergency response team formation and training",
  emergencyPlanHighlight4: "Post-emergency recovery and evaluation procedures",
  aparTrainingSession: "APAR Training Session",
  evacuationDrill: "Evacuation Drill",
  
  // Traffic Safety Initiatives
  trafficSafetyTitle: "Traffic Safety Initiatives",
  trafficSafetySubtitle: "Ensuring safe commuting and transportation for all employees",
  
  // Safety Riding Program
  safetyRidingTitle: "Safety Riding Program",
  safetyRidingDesc: "Every year, we organize external training with the theme of Safety Riding, working with professionals, as an effort to increase awareness and safe driving skills for employees. Additionally, with monthly safety riding check activities, we hope to cultivate a culture of safe and responsible driving.",
  safetyRidingHighlight1: "Annual external Safety Riding training with professionals",
  safetyRidingHighlight2: "Monthly safety riding checks and vehicle inspections",
  safetyRidingHighlight3: "Building a culture of safe and responsible driving",
  safetyRidingHighlight4: "Increasing employee awareness of traffic safety",
  safetyRidingTraining: "Safety Riding Training",
  monthlyVehicleCheck: "Monthly Vehicle Check",
  
  // Health Promotion
  healthPromotionTitle: "Health Promotion",
  healthPromotionSubtitle: "Supporting employee well-being through various health and wellness programs",
  
  // Employee Wellness Programs
  employeeWellnessTitle: "Employee Wellness Programs",
  employeeWellnessDesc: "We realize the importance of health and hygiene of our employees. If employees are healthy and free from disease, they will be happy at work and work efficiently. The company provides various sports activity options to support physical fitness and mental well-being.",
  wellnessHighlight1: "Well-equipped gym facility for employee use",
  wellnessHighlight2: "Regular aerobic exercise sessions",
  wellnessHighlight3: "Badminton, table tennis, and volleyball clubs",
  wellnessHighlight4: "Soccer team and running club for sports enthusiasts",
  
  // Activity Names
  gym: "Gym",
  aerobic: "Aerobic",
  badminton: "Badminton",
  tableTennis: "Table Tennis",
  volleyball: "Volleyball",
  soccer: "Soccer",
  photos: "photos",
  
  // Related Topics
  relatedTopicsTitle: "Related Sustainability Topics",
  relatedTopicsSubtitle: "Explore more about our sustainability initiatives",
  conceptOfSustainability: "Concept of Sustainability",
  environmentalInitiatives: "Environmental Initiatives",
  socialContributionInitiatives: "Social Contribution Initiatives",
  
  // Buttons
  backToSustainability: "Back to Sustainability"
};